import { useEffect, useRef, useState } from 'react';
import {
    initLoginAPI,
    checkAccountPwdAPI,
    checkEKBAAnswerAPI,
    getAuthorize,
    getAccessToken,
    renewAccessToken,
    getUserInfo,
    logout,
    revokeSession,
    getUserInfoAdditional,
    initEkbaAPI,
    renewSSO
} from './BetSlipAPI';
import { useTranslation } from 'react-i18next';
import { removeCurrentSessionRecords } from '../Common/CurrentSessionRecords';
import { glassboxSetUserInfo } from '../Common/utils/glassbox';
import { setTokenToSession } from './LoginBase';
import { LogoutReminderPopupType } from '../Common/constants';

const getSessionToken = () => {
    const accessToken = window.sessionStorage.getItem('access_token') || '';
    const refreshToken = window.sessionStorage.getItem('refresh_token') || '';

    return {
        access_token: accessToken,
        refresh_token: refreshToken
    };
};

export const getSessionLoginAccount = () => {
    return window.sessionStorage.getItem('account') || '';
};

export const setUserInfoToSession = (userInfo) => {
    window.sessionStorage.setItem('login_firstNameEn', userInfo?.bettingProfile?.personalInfo.firstNameEn);
    window.sessionStorage.setItem('login_firstNameZhHk', userInfo?.bettingProfile?.personalInfo.firstNameZhHk);
    window.sessionStorage.setItem('login_lastNameEn', userInfo?.bettingProfile?.personalInfo.lastNameEn);
    window.sessionStorage.setItem('login_lastNameZhHk', userInfo?.bettingProfile?.personalInfo.lastNameZhHk);
    window.sessionStorage.setItem(
        'login_maskedMobilePhoneNumber',
        userInfo?.bettingProfile?.contactInfo.maskedMobilePhoneNumber
    );
    window.sessionStorage.setItem('login_mobilePhoneNumber', userInfo?.bettingProfile?.contactInfo.mobilePhoneNumber);
    window.sessionStorage.setItem('login_webAccountLoginName', userInfo?.webProfile?.personalInfo?.webAccountLoginName);
};

const setUserInfoAdditionalToSession = (userInfoAdditional) => {
    //console.log(userInfoAdditional);
    window.sessionStorage.setItem('login_memberCategoryCode', userInfoAdditional?.memberCategoryCode);
    window.sessionStorage.setItem('login_age', userInfoAdditional?.age);
    window.sessionStorage.setItem('login_gender', userInfoAdditional?.gender);
    userInfoAdditional?.priorityCardTier &&
        window.sessionStorage.setItem('login_priorityCardTier', userInfoAdditional.priorityCardTier);
};

const removeToken = () => {
console.debug('22 removeToken')
    window.sessionStorage.removeItem('access_token');
    window.sessionStorage.removeItem('refresh_token');
    window.sessionStorage.removeItem('id_token');
    window.sessionStorage.removeItem('login_account');
    window.sessionStorage.getItem('login_priorityCardTier') &&
        window.sessionStorage.removeItem('login_priorityCardTier');
};

const getAgeGroup = (age) => {
    // const age = window.sessionStorage.getItem('login_age')
    if (!age || age === 'undefined') return '00';
    if (age < 18) return '01';
    if (age < 26) return '02';
    if (age > 80) return '14';
    let ageGroup = 2;
    ageGroup += Math.ceil((age - 25) / 5);
    if (ageGroup > 10) return ageGroup + '';
    else {
        return '0' + ageGroup;
    }
};
const getGenderCode = (gender) => {
    if (!gender || gender === 'undefined') return '0';
    if (gender === 'M') return '1';
    if (gender === 'F') return '2';
};
const getMemberCode = (member) => {
    if (!member) return '0';
    if (member === 'FULL') return '2';
    if (member === 'RACE') return '3';
    if (member === 'RCIM') return '4';
    return '0';
};

const getPriorityCardCode = (priorityCardCode) => {
    if (!priorityCardCode && priorityCardCode !== '') return '0';
    if (priorityCardCode) return 'Y';
    return 'N';
};

const loginStatus = {
    isBusy: false
};

export const GetLoginStatus = () => {
    return loginStatus;
};

export function SetLoginBusyStatus(status) {
    loginStatus.isBusy = status;
}

export const callLogoutApi = (accessToken) => {
    revokeSession(accessToken);
    logout(accessToken);
};

export const isLogonHigh = () => {
    return window.sessionStorage.getItem('is_logon') == 1;
};

export const getProfileByToken = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );
    const profile = JSON.parse(jsonPayload);
    return profile;
};

const processIdToken = (id_token, otherInfo) => {
    if (!id_token) return;
    sessionStorage.removeItem('customerSegment');
    const profile = getProfileByToken(id_token);

    /*
        https://deopjira01.corp.hkjc.com/browse/PRJ1027-4820

        Priority Card Holder: 0 – N/A; Y – Has Priority Card; N – Has No Priority Card
        CBP Segment: 00000 – N/A, 00001 -00011 – Indicates the customer CBP segments
        Racing Participation: ‘Y’/’N’ Indicates whether customer has participation in racing
        Football Participation:	‘Y’/’N’ (Similar as above)
        M6 Participation: ‘Y’/’N’ (Similar as above)
        Priority Card Holder: 0 – N/A; Y – Has Priority Card; N – Has No Priority Card
        Member:	0 – N/A; 1 – Owners; 2 – Full Members; 3 – Racing Members; 4 – Racing Club
        Age group: 00 – N/A; 01 – under 18; 02 – 18-25;
                    03 – 26-30; 04 – 31-35; 05 – 36-40;
                    06 – 41-45; 07 – 46-50; 08 – 51-55;
                    09 – 56-60; 10 – 61-65; 11 – 66-70;
                    12 – 71-75; 13 – 76-80; 14 – above 80
        Gender:	0 – N/A; 1 – Male; 2 – Female
        Betting Account Indicator: ‘Y’/’N’ Indicate whether the customer has a betting account
        Language: Hardcoded as 0
        SpeedBet Customer: 0 – N/A; Y – SpeedBet customer; N – Non-SpeedBet customer
        Web TV Indicator: ‘Y’/’N’ Indicate whether the customer has access to WebTV.

        String character sequence
        =========================
        Character	Information
        0	Priority Card Holder
        1-5	CBP Segment
        6	Racing Participation
        7	Football Participation
        8	M6 Participation
        9	Member
        10-11	Age group
        12	Gender
        13	Betting Account Indicator
        14	Language
        15	SpeedBet Customer
        16	Football Web TV Indicator
        */

    var priority = getPriorityCardCode(otherInfo?.priorityCardTier);
    var cbp = '00000'; // GetDataStore('cbp_seg');
    if (cbp == '') cbp = '00000';
    else if (cbp.length < 5) cbp = new Array(6 - cbp.length).join('0') + cbp;
    var racing = profile.racingParticipation ? 'Y' : 'N';
    var football = profile.footballParticipation ? 'Y' : 'N';
    var marksix = profile.m6Participation ? 'Y' : 'N';
    var member = getMemberCode(otherInfo?.memberCategoryCode);
    var ageGroup = getAgeGroup(otherInfo?.age);
    var gender = getGenderCode(otherInfo?.gender);
    var bettingAC = profile.betAcct?.length > 0 ? 'Y' : 'N';
    var speedbet = profile.speedBet ? 'Y' : 'N';
    let webTV = profile.webTV ? 'Y' : 'N';
    let language = '0';

    const customerSegment =
        priority +
        cbp +
        racing +
        football +
        marksix +
        member +
        ageGroup +
        gender +
        bettingAC +
        language +
        speedbet +
        webTV;
    sessionStorage.setItem('customerSegment', customerSegment);
    if (profile.c_hash?.length > 0) {
        sessionStorage.setItem('customerHash', profile.c_hash);
    }
    sessionStorage.setItem('webTV', profile.webTV == true);
};

export const renewTokens = async (clientId = 'JCBW') => {
    const refreshToken = getSessionToken().refresh_token;
    if (refreshToken == null || refreshToken == '') {
        clearInterval(sessionStorage.getItem('tokenIntervalId'));
        //console.log('stop token renew ' + Date() + ' ' + sessionStorage.getItem('tokenIntervalId'));
    } else {
        const token = await renewAccessToken(refreshToken, clientId);
        if (token?.access_token) {
            await renewSSO(token.access_token);
        }
        return token;
    }
    return null;
};

